export default "__VITE_PUBLIC_ASSET__cb433590__"